export default {
  get: `query getAllergies {
    getAllergies
    {
        id,
        name
    }
  }`,
};



// WEBPACK FOOTER //
// ./src/graphql/queries/allergy.js